import { render } from "./GoalSelectionNav.vue?vue&type=template&id=1968e922"
import script from "./GoalSelectionNav.vue?vue&type=script&lang=js"
export * from "./GoalSelectionNav.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__